import qs from 'query-string'
import { clientEnv } from '@retailer-platform/dashboard/env'

interface PasswordResetLinkOptions {
  authService: boolean
  email: string
}

export const passwordResetLink = ({ authService, email }: PasswordResetLinkOptions) => {
  const queryParamsString = qs.stringify({
    email: email,
  })

  if (authService) {
    return `${clientEnv.PUBLIC_CLIENT_AUTH_SERVICE_BASE_URL}/request-password-reset?${queryParamsString}`
  } else {
    return `/public/request-account-setup?${queryParamsString}`
  }
}
